<template>
    <Head>
        <title>Default Title</title>
        <meta
            type="description"
            content="Default meta description"
            head-key="description"
        />
    </Head>
    <main data-theme="default">
        <section class="">
            <slot />
        </section>
    </main>
</template>

<script setup></script>

<script>
export default {
    props: {},
};
</script>

<style>
main {
    background-color: white;
}
</style>
